<template>
  <div class="relative h-full w-full">
    <video
      v-if="videoSrc"
      v-bind="$attrs"
      :src="videoSrc"
      :class="['h-full w-full', classes]"
      @loadeddata="onLoadedData"
      @error="onError" />
    <div v-show="!videoSrc" ref="placeholderRef" class="absolute inset-0 h-full w-full" />
  </div>
</template>

<script setup lang="ts">
import { onUnmounted, ref, watch } from 'vue';
import type { Ref } from 'vue';
import { useIntersectionObserver } from '@/composables/useIntersectionObserver';
import { getAssetsS3Path, S3PathType } from '@/helpers/assets';

interface Props {
  path: string;
  type: S3PathType;
  poster?: string;
  classes?: string[];
}

const props = defineProps<Props>();
const videoSrc = ref('');
const placeholderRef: Ref<HTMLDivElement | null> = ref(null);
let controller = new AbortController();

const onLoadedData = () => {};
const onError = () => {};

const loadAsset = async () => {
  try {
    const src = await getAssetsS3Path(props.path, props.type, controller);
    videoSrc.value = src || '';
  } catch (e) {
    console.warn('Failed to load video asset', e);
  }
};

// Watch for path changes and reload the video
watch(
  () => props.path,
  () => {
    controller.abort();
    controller = new AbortController();
    videoSrc.value = '';
    loadAsset();
  }
);

useIntersectionObserver(placeholderRef, loadAsset);

onUnmounted(() => {
  controller.abort();
});
</script>
